/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling
 * (C) Copyright IBM Corp. 2014, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


define([
	'baglass/core-client/js/core-client/ui/core/View'
], function(View) {

	var AutoHidingControl = View.extend({

		autohide: null,

		init: function(options) {
			AutoHidingControl.inherited('init', this, arguments);

			options = options || {};
			this.autohide = options.autohide || 6000;
			this.startHidden = options.startHidden || false;
			this.hidden = true;
		},

		render: function() {
			return this._renderContent().then(() => {
				this.$el.on('mouseenter', this._cancelAutoHide.bind(this));
				this.$el.on('mouseleave', this._setAutoHide.bind(this));
				this.hidden = false;

				if(this.startHidden) {
					this.hide({ duration: 0 });
				} else {
					this.show({ duration: 0 });
				}
			});
		},

		destroy: function() {
			this._cancelAutoHide();
			return this.hide().then(() => {
				this.remove();
			});
		},

		toggle: function() {
			if(this.hidden) {
				this.show();
			} else {
				this.hide();
			}
		},

		_cancelAutoHide: function() {
			if(this.timeout) {
				clearTimeout(this.timeout);
			}
			this.timeout = null;
		},

		_setAutoHide: function() {
			this.timeout = setTimeout(this.hide.bind(this), this.autohide);
		},

		show: function(options = {}) {
			return Promise.delay(options.delay || 0).then(() => {
				return this._show(options).then(() => {
					this.$el.attr('aria-hidden', 'false');
					this.hidden = false;
					this._cancelAutoHide();
					this._setAutoHide();

				});
			});
		},

		hide: function(options = {}) {
			if(this.hidden) {
				return Promise.resolve();
			}

			return this._hide(options).then(() => {
				this.$el.attr('aria-hidden', 'true');
				this.hidden = true;
			});
		},

		// Override these!

		_renderContent: function() {
			return Promise.resolve();
		},

		// _show is expected to return a promise that resolves when it is done showing.
		_show: function() {
			return Promise.resolve();
		},

		// _hide is expected to return a promise that resolves when it is done hiding.
		_hide: function() {
			return Promise.resolve();
		}
	});

	return AutoHidingControl;
});
